export class PlanModel {
    constructor(json) {
        if (!json) {
            return null;
        }

        this.name = json.name;
        this.price = json.price / 100;
        this.id = json.stripe_plan_id;
        this.stripePlanId = json.stripe_plan_id;
        this.displayOrder = json.display_order;
    }
}
